<section class="section footer">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">

        <!-- Header: Logo + Redes Sociais -->
        <div class="footer-header">
          <div class="footer-logo-container">
           <img src="./assets/images/logo-footer.svg" alt="Portal de Compras Públicas" class="footer-logo">
          </div>
          <div class="footer-social-icons">
            <a href="https://www.instagram.com/oportaldecompraspublicas/" class="social-icon"><img src="./assets/images/instagram.svg" alt="Instagram"></a>
            <a href="https://www.facebook.com/portaldecompraspublicas" class="social-icon"><img src="./assets/images/facebook.svg" alt="Facebook"></a>
            <a href="https://www.youtube.com/c/portaldecompraspublicas" class="social-icon"><img src="./assets/images/youtube.svg" alt="Youtube"></a>
            <a href="https://www.tiktok.com/@oportaldecompraspublicas" class="social-icon"><img src="./assets/images/tiktok.svg" alt="TikTok"></a>
            <a href="https://www.linkedin.com/company/portaldecompraspublicas/posts/?feedView=all&viewAsMember=true" class="social-icon"><img src="./assets/images/linkedin.svg" alt="LinkedIn"></a>
            <a href="https://api.whatsapp.com/send/?phone=556130035455&text&type=phone_number&app_absent=0" class="social-icon"><img src="./assets/images/whatsapp.svg" alt="WhatsApp"></a>
          </div>
        </div>

        <!-- Seção Parceiros -->
        <div class="footer-partners">
          <h3 class="section-title-new">Parceiros</h3>
          <div class="partners-logos">
            <img src="./assets/images/instituto-protege.svg" alt="Instituto Protege" class="partner-logo">
            <img src="./assets/images/agm.svg" alt="AGM" class="partner-logo">
            <img src="./assets/images/effecti.svg" alt="Effecti" class="partner-logo">
            <img src="./assets/images/forseti.svg" alt="Forseti" class="partner-logo">
            <img src="./assets/images/conlicitacao.svg" alt="Conlicitacao" class="partner-logo">
          </div>
        </div>

        <!-- Seção Central de Atendimento + FAQ -->
        <div class="footer-main-content">

          <!-- Central de Atendimento -->
          <div class="contact-section">
            <h3 class="section-title-new">Central de Atendimento</h3>
            <div class="contact-info">
              <p class="contact-hours">Capitais, Regiões Metropolitanas e WhatsApp: <strong>3003-5455</strong></p>
              <p class="contact-phone">Demais Regiões: <strong>0800 730 5455</strong></p>
              <p class="contact-mobile">Região Sul: <strong>(48) 3771-4672 | (51) 3103-9615</strong></p>
              <p class="contact-mobile">Brasília: <strong>(61) 3120-3700 | (61) 3142-4887</strong></p>
              <p class="contact-note">Atendimento de segunda a sexta, das 8h às 18h (horário de Brasília), exceto feriados.</p>
            </div>
          </div>

          <!-- FAQ Section -->
          <div class="faq-section">
            <div class="faq-item">
              <div class="faq-icon"><img src="./assets/images/portal.svg" alt="FAQ Icon 1"></div>
              <div class="faq-content">
                <p class="faq-question">Quer vender para o governo?</p>
                <a href="mailto:fornecedores@portaldecompraspublicas.com.br" class="faq-email">
                  fornecedores@portaldecompraspublicas.com.br
                </a>
              </div>
            </div>

            <div class="faq-item">
              <div class="faq-icon"><img src="./assets/images/portal.svg" alt="FAQ Icon 2"></div>
              <div class="faq-content">
                <p class="faq-question">É ente público?</p>
                <a href="mailto:compradores@portaldecompraspublicas.com.br" class="faq-email">
                  compradores@portaldecompraspublicas.com.br
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>
<!-- Seção de Certificações ATC -->
<section class="certifications-section">
  <div class="container">
    <div class="certifications-content">

      <!-- ATC Logo e Texto -->
      <div class="atc-info">
        <div class="atc-logo-container">
          <img src="./assets/images/atcg.png" alt="ATC" class="atc-logo">
        </div>
        <div class="atc-description">
          <p>O Portal de Compras Públicas é associado à ATCG (Associação de Tecnologia e Compras Governamentais), reforçando seu compromisso com a transparência, inovação e boas práticas no setor público. Atuamos em conformidade com a legislação vigente, com processos e soluções alinhados às exigências legais e regulatórias. <a href="https://atcg.org.br/documentos/">Link de Acesso: Documentos - Associação das Empresas de Tecnologia para Contratações Governamentais</a></p>
        </div>
      </div>

      <!-- Badges de Certificação -->
      <div class="certification-badges">
        <img src="./assets/images/iso-1.png" alt="ISO 27001 Certificação" class="cert-badge">
        <img src="./assets/images/iso-2.png" alt="ISO 9001 Certificação" class="cert-badge">
        <img src="./assets/images/iso-3.png" alt="LGPD Certificação" class="cert-badge">
        <img src="./assets/images/iso-4.png" alt="Security Certificação" class="cert-badge">
      </div>

    </div>

    <!-- Logos de Parceiros Adicionais -->
    <div class="additional-partners">
      <img src="./assets/images/garagem.png" alt="Garagem" class="partner-additional">
      <img src="./assets/images/selo.png" alt="Selo" class="partner-additional">
      <img src="./assets/images/selo-startout.png" alt="Selo" class="partner-additional">
      <img src="./assets/images/selo-gptw.png" alt="Gptw" class="partner-additional">
      <img src="./assets/images/abes.png" alt="ABES" class="partner-additional">
    </div>

    <!-- Texto do Rodapé -->
    <div class="certifications-footer">
      <p class="footer-address">
        SIA Trecho 17, Rua 20, Lote 90 – 2º andar, Brasília/DF – CEP 71.200-256</p>
        <p class="footer-address">©{{ year }} Portal de Compras Públicas – Todos os direitos reservados</p>
       <p class="footer-address">CNPJ: 09.397.355/0001-30 – Ecustomize Consultoria em Software S/A
      </p>
    </div>

  </div>
</section>
